import type { NodeState, WorkflowNodeType } from 'flow/service/graph';
import {
  DOT_SIZE,
  DOT_MARGIN_FROM_NODE,
  DOT_RIGHT_PADDING,
} from './NodeConnector/constants';

/**
 * The node's interactive hover area is enlarged beyond its visible bounds so that
 * getting *close* to a node reveals its add-child / link-node connector and menu,
 * instead of requiring the mouse to land precisely on the node box (BUILD-2803).
 *
 * Padding is kept small so adjacent nodes' hover areas stay disjoint. Horizontally
 * the gap is COLUMN_SPACING (64px) — the 38px right reach + 8px left is well clear.
 * Vertically the row pitch is NODE_HEIGHT + ROW_SPACING = 48px, so standard 32px-tall
 * nodes have a 16px gap and 6px top/bottom leaves a 4px dead zone. Taller node types
 * (riskCalculation NODE_HEIGHT_XL=48, snippet SNIPPET_NODE_HEIGHT=44) have little or no
 * true gap; their halos can overlap in the seam between rows, but that band sits behind
 * both node bodies (z-index:-1) so hovering a body still resolves unambiguously — only
 * the thin inter-node seam is shared, where either neighbour is a reasonable target.
 */
export const HOVER_AREA_PADDING_Y = 6;
export const HOVER_AREA_PADDING_LEFT = 8;
// Reach exactly to the connector, which sits DOT_SIZE + DOT_MARGIN_FROM_NODE +
// DOT_RIGHT_PADDING (38px) to the right of the node — still well under COLUMN_SPACING.
export const HOVER_AREA_PADDING_RIGHT = DOT_SIZE + DOT_MARGIN_FROM_NODE + DOT_RIGHT_PADDING;

export const NODES_SUPPORTING_CONNECTOR: WorkflowNodeType[] = [
  'folder',
  'inputAttribute',
  'outputAttribute',
  'service',
  'tag',
  'matrixModel',
  'outcomeReason',
  'riskCalculation',
];


export const NODES_SUPPORTING_MENU: WorkflowNodeType[] = [
  'inputAttribute',
  'matrixModel',
  'outcome',
  'outputAttribute',
  'service',
  'snippet',
  'tag',
  'exit',
  'outcomeReason',
  'riskCalculation',
];

export const NODE_STATES_SUPPORTING_MENU: NodeState[] = [
  'hovered',
  'focused',
  'focused-hovered',
];
